import { AutomationChannel } from "@redotech/redo-flows-core-schema-common/common";
import type { AiContextLibrary } from "@redotech/redo-marketing-ai-common/ai-context-library";
import {
  AiContextLibrarySchema,
  AiContextLibraryType,
} from "@redotech/redo-marketing-ai-common/ai-context-library";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const AutomationChannelValues = [
  AutomationChannel.Email,
  AutomationChannel.SMS,
] as const;

const getContextLibraryItemsByScenarioInputSchema_ = z.object({
  marketingAgentPromptIds: z.array(zExt.objectId()).optional(),
  channel: createEnum(AutomationChannelValues).optional(),
  type: z.nativeEnum(AiContextLibraryType).optional(),
  smsTemplateId: zExt.objectId().optional(),
});

export interface GetContextLibraryItemsByScenarioInput extends z.infer<
  typeof getContextLibraryItemsByScenarioInputSchema_
> {}
export const getContextLibraryItemsByScenarioInputSchema: z.ZodType<GetContextLibraryItemsByScenarioInput> =
  getContextLibraryItemsByScenarioInputSchema_;

const getContextLibraryItemsByScenarioOutputSchema_ = z.object({
  items: z.array(AiContextLibrarySchema as z.ZodType<AiContextLibrary>),
});

export interface GetContextLibraryItemsByScenarioOutput extends z.infer<
  typeof getContextLibraryItemsByScenarioOutputSchema_
> {}
export const getContextLibraryItemsByScenarioOutputSchema: z.ZodType<GetContextLibraryItemsByScenarioOutput> =
  getContextLibraryItemsByScenarioOutputSchema_;

export const getContextLibraryItemsByScenario = {
  name: "getContextLibraryItemsByScenario" as const,
  input: getContextLibraryItemsByScenarioInputSchema,
  output: getContextLibraryItemsByScenarioOutputSchema,
};
